import { gql } from 'graphql-request'

export const GET_GIFT_TYPES = gql`
  query GET_GIFT_TYPES(
    $take: Int
    $skip: Int
    $typeFilterDate: TypeFilter
    $dateInitial: String
    $dateFinal: String
    $active: Boolean
  ) {
    getGiftsTypes(
      take: $take
      skip: $skip
      typeFilterDate: $typeFilterDate
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      active: $active
    ) {
      error
      status
      data {
        id
        name
        description
        isLocked
        isLuck
        isPackage
        minLevel
        minVip
      }
    }
  }
`

export const GET_GIFT_TYPE = gql`
  query GET_GIFT_TYPE($giftTypeId: Int!) {
    getGiftType(giftTypeId: $giftTypeId) {
      error
      status
      data {
        name
        description
        gift {
          id
          name
          description
          value
          imgGift
          animationSpeedCenter
          animationSpeedSeat
        }
      }
    }
  }
`
